// extracted by mini-css-extract-plugin
export default {"notifications-list":"quotation-notification_notifications-list__1ldWS"};